export const experience = [
   {
    title: "Cyber Risk & Compliance Intern",
    company: "Excelerate (Remote)",
    period: "Oct 2025 – Nov 2025",
    details: [
      "Performed compliance gap analysis and threat mapping for cloud-reliant organizations aligned with NIST CSF and ISO/IEC 27001:2022.",
      "Conducted vulnerability assessments and recommended mitigations including MFA enforcement and RBAC.",
      "Bridged technical security hardening with organizational governance and risk management requirements."
    ]
  },
  {
    title: "Data Fellowship",
    company: "Code for Nepal & DataCamp",
    period: "Apr 2025 – Present",
    details: [
      "Selected for a competitive data fellowship focused on Python, data systems, and AI governance.",
      "Completed advanced coursework in data engineering, data ethics, and responsible AI practices.",
      "Applied data-driven approaches to analyze societal and governance-related challenges."
    ]
  },
 {
    title: "Data Analyst Intern",
    company: "Excelerate (Remote)",
    period: "May 2025 – Jun 2025",
    details: [
      "Analyzed datasets to support decision-making with a focus on data integrity and quality.",
      "Created reports and visualizations to communicate insights to stakeholders.",
      "Used Excel, Google Sheets, and Python for data analysis and preprocessing."
    ]
  },
  {
    title: "Software Engineer (CBDC)",
    company: "Nepal Rastra Bank",
    period: "Jul 2024 – Jan 2025",
    details: [
      "Contributed to secure digital currency infrastructure research, aligning system design with financial security and regulatory considerations.",
      "Developed and optimized frontend components for the CBDC prototype using JavaScript and TypeScript.",
      "Integrated and optimized secure REST APIs, improving backend communication and system reliability.",
      "Conducted cryptographic security research on wholesale CBDC to support secure digital transactions."
    ]
  },
  {
    title: "Software Engineer Intern (CBDC)",
    company: "Nepal Rastra Bank",
    period: "Apr 2024 – Jul 2024",
    details: [
      "Contributed to CBDC research and development, supporting both frontend and backend features.",
      "Implemented responsive UI components using Next.js and modern CSS frameworks.",
      "Assisted in API development and Docker-based containerization to improve deployment consistency and scalability."
    ]
  },
  {
    title: "MERN Stack Developer",
    company: "Khudra.Asia (Contract)",
    period: "Sep 2023 – Feb 2024",
    details: [
      "Developed dynamic and responsive UI components using React.js, Tailwind CSS, and Bootstrap.",
      "Built scalable RESTful APIs using Node.js and Express.js with authentication and authorization mechanisms.",
      "Optimized MongoDB queries and indexing to improve application performance and scalability.",
      "Participated in code reviews, debugging, and performance tuning to enhance system reliability."
    ]
  }
];
  
  export const education = [
    {
      degree: "B.E. Computer Engineering",
      institution: "School of Engineering, Kathmandu University",
      period: "Aug 2019 - Aug 2024",
    },
    {
      degree: "National Education Board (+2 Science)",
      institution: "Kanchanjunga English Secondary School",
      period: "June 2017 - June 2019",
    },
    {
      degree: "Secondary Education Examination (SEE)",
      institution: "Shree Harikul Model Secondary School",
      period: "April 2017",
    },
  ];
  
